var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuiltInTransparency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 660,
    viewBox: "0 0 640 660",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6128_39319)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 150.166,
    y1: 5.32551e-8,
    x2: 150.166,
    y2: 534,
    stroke: "#F8F7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.389,
    y1: 5.32551e-8,
    x2: 277.389,
    y2: 534,
    stroke: "#F8F7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.611,
    y1: 5.32551e-8,
    x2: 404.611,
    y2: 534,
    stroke: "#F8F7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 531.834,
    y1: 5.32551e-8,
    x2: 531.834,
    y2: 534,
    stroke: "#F8F7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 90,
    x2: 40,
    y2: 90,
    stroke: "#F8F7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 328.52,
    x2: 40,
    y2: 328.52,
    stroke: "#F8F7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 209.26,
    x2: 40,
    y2: 209.26,
    stroke: "#F8F7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 447.78,
    x2: 40,
    y2: 447.78,
    stroke: "#F8F7FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_6128_39319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.596 353.646C626.676 369.299 626.82 394.701 599.915 410.354L369.784 544.26C342.88 559.913 299.111 559.913 272.031 544.26L40.4123 410.354C13.3323 394.701 13.1725 369.315 40.0766 353.662L270.208 219.74C297.112 204.087 340.897 204.087 367.977 219.74L599.596 353.63V353.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.596 353.646C626.676 369.299 626.82 394.701 599.915 410.354L369.784 544.26C342.88 559.913 299.111 559.913 272.031 544.26L40.4123 410.354C13.3323 394.701 13.1725 369.315 40.0766 353.662L270.208 219.74C297.112 204.087 340.897 204.087 367.977 219.74L599.596 353.63V353.646Z",
    stroke: "#DDEFFF",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.566 435.781C350.909 435.781 348.507 435.198 346.578 434.069L222.222 362.2C219.529 360.634 218 358.157 218 355.388C218 352.365 219.82 349.597 222.986 347.775L230.992 343.149C233.358 341.765 236.342 341 239.363 341C242.02 341 244.422 341.583 246.35 342.712L370.743 414.581C373.436 416.147 374.965 418.624 374.965 421.392C374.965 424.416 373.145 427.184 369.979 429.005L361.972 433.631C359.607 435.016 356.623 435.781 353.602 435.781H353.566Z",
    fill: "#BECEE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.049 303.785C244.474 306.728 242.172 309.671 239.871 310.311L223.122 315.046C222.355 315.237 221.652 315.173 221.141 314.854L354.235 392.269C354.746 392.589 355.449 392.653 356.216 392.461L372.965 387.726C375.266 387.086 377.568 384.143 378.143 381.2L245.049 303.785Z",
    fill: "url(#paint0_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.52 297.323L226.255 299.115C222.931 300.01 219.607 304.233 218.776 308.52L218.2 311.335C217.625 314.15 218.328 316.325 219.799 317.157L352.893 394.572C351.422 393.74 350.719 391.565 351.295 388.75L351.87 385.935C352.701 381.648 356.089 377.425 359.349 376.53L365.614 374.802L232.52 297.387V297.323Z",
    fill: "url(#paint1_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.385 140.766L306.291 63.4144L306.738 61.0471L439.833 138.398L439.385 140.766Z",
    fill: "#B7C3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.672 116.198L313.642 38.7825C314.921 39.5502 315.56 41.4056 315.049 43.9008L313.323 52.73C312.619 56.5048 309.615 60.2156 306.738 60.9833L439.832 138.398C442.709 137.567 445.65 133.856 446.417 130.145L448.143 121.316C448.654 118.821 448.015 116.965 446.736 116.198H446.672Z",
    fill: "url(#paint2_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.143 381.2L245.049 303.785L294.847 49.595L427.941 127.01L378.143 381.2Z",
    fill: "#62A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.69 113.638C448.59 112.551 450.955 115.75 449.932 120.804L448.206 129.633C447.247 134.688 443.22 139.678 439.32 140.766L439.768 138.398C442.645 137.567 445.585 133.856 446.352 130.145L448.078 121.316C448.781 117.541 447.055 115.174 444.179 116.005L436.316 118.245C433.439 119.077 430.499 122.787 429.731 126.498L379.933 380.688C379.102 384.975 375.714 389.198 372.454 390.093L355.705 394.828C352.381 395.724 350.399 393.036 351.23 388.75L351.806 385.935C352.637 381.648 356.025 377.426 359.285 376.53L365.55 374.802L365.102 377.17L358.837 378.897C356.536 379.537 354.235 382.48 353.659 385.423L353.084 388.238C352.509 391.181 353.915 393.1 356.216 392.461L372.965 387.726C375.266 387.086 377.568 384.143 378.143 381.2L427.942 127.01C428.9 121.956 432.928 116.965 436.827 115.878L444.69 113.638Z",
    fill: "#E4E7ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.92 36.4791C314.025 35.9673 312.875 35.8393 311.596 36.2232L303.733 38.4625C299.834 39.5501 295.87 44.5405 294.848 49.5949L427.942 127.01C428.901 121.956 432.928 116.965 436.827 115.878L444.69 113.638C446.033 113.254 447.12 113.382 448.015 113.894L314.92 36.4791Z",
    fill: "url(#paint3_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.024 152.346L323.103 117.093C321.377 116.07 320.354 113.383 320.801 111.079C321.249 108.776 322.975 107.688 324.765 108.712L385.686 143.965C387.412 144.988 388.435 147.676 387.988 149.979C387.54 152.282 385.814 153.37 384.024 152.346Z",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.97 194.06L303.989 144.348C302.263 143.325 301.241 140.638 301.688 138.334C302.136 136.031 303.862 134.943 305.651 135.967L391.632 185.679C393.358 186.703 394.381 189.39 393.933 191.693C393.486 193.997 391.76 195.084 389.97 194.06Z",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.198 213.766L300.218 164.054C298.492 163.031 297.469 160.343 297.917 158.04C298.364 155.737 300.09 154.649 301.88 155.673L387.861 205.385C389.587 206.409 390.609 209.096 390.162 211.399C389.714 213.702 387.988 214.79 386.198 213.766Z",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.463 223.107L296.445 183.76C294.719 182.736 293.697 180.049 294.144 177.746C294.592 175.443 296.318 174.355 298.108 175.379L366.125 214.726C367.851 215.75 368.874 218.437 368.426 220.74C367.979 223.043 366.253 224.131 364.463 223.107Z",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.591 253.177L292.61 203.465C290.884 202.442 289.862 199.755 290.309 197.451C290.757 195.148 292.483 194.06 294.273 195.084L380.253 244.796C381.979 245.82 383.002 248.507 382.554 250.81C382.107 253.113 380.381 254.201 378.591 253.177Z",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.303 325.666L325.532 299.179C325.212 298.987 325.021 298.475 325.085 298.027C325.148 297.579 325.532 297.387 325.852 297.579L371.623 324.067C371.942 324.259 372.134 324.771 372.07 325.218C372.006 325.666 371.623 325.858 371.303 325.666Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.176 238.398L288.902 223.171C287.176 222.148 286.154 219.46 286.601 217.157C287.049 214.854 288.775 213.766 290.565 214.79L316.838 230.017C318.564 231.041 319.587 233.728 319.139 236.031C318.692 238.334 316.966 239.422 315.176 238.398Z",
    fill: "#D7E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.472 314.854C366.061 314.15 363.249 311.847 361.906 307.816C361.331 307.816 360.883 307.816 360.692 307.752C356.153 307.176 352.765 305.257 350.655 302.122C348.865 299.563 348.098 296.62 348.546 294.252C347.97 295.468 346.82 296.428 345.222 297.067C341.322 298.603 336.591 297.579 332.884 294.508C331.094 292.973 329.496 290.989 328.345 288.622C327.13 286.127 327.194 283.184 328.473 281.265C329.751 279.409 332.117 279.473 332.82 279.473C336.911 279.473 340.299 282.16 343.432 285.039C344.582 286.063 345.413 287.151 346.18 288.238C345.797 287.343 345.285 286.383 344.646 285.295L344.199 284.527C342.664 282.032 341.066 279.537 340.811 276.658C340.427 272.435 343.368 269.812 346.308 269.492C347.97 269.3 349.249 269.812 350.591 270.516C351.742 271.156 353.084 271.924 354.107 273.267C355.13 274.547 355.961 276.594 355.386 278.258L353.532 277.682C353.788 276.85 353.34 275.506 352.573 274.483C351.742 273.459 350.655 272.755 349.632 272.243C348.354 271.54 347.459 271.284 346.5 271.412C344.518 271.604 342.473 273.459 342.728 276.466C342.92 278.833 344.39 281.201 345.797 283.504L346.244 284.272C348.098 287.343 349.057 289.838 348.993 291.949C349.121 292.077 349.185 292.205 349.313 292.269C349.76 291.565 350.336 290.989 351.039 290.542C351.87 290.03 352.765 289.582 353.788 289.326C355.705 288.878 358.454 289.582 360.372 291.053C361.778 292.077 362.673 293.549 362.801 295.084C362.929 296.364 362.609 297.579 361.778 298.475C360.18 300.33 356.409 300.906 350.847 296.428C350.655 296.3 350.463 296.108 350.272 295.98C350.336 297.579 351.039 299.371 352.126 301.034C353.979 303.721 356.792 305.321 360.819 305.833C360.883 305.833 361.075 305.833 361.331 305.833C360.947 303.529 361.331 301.162 362.354 299.435C362.929 298.475 364.911 295.788 367.276 296.108C368.107 296.172 369.258 296.684 369.897 298.667C370.6 300.65 370.025 303.018 369.194 304.233C367.723 306.408 365.55 307.304 363.824 307.624C364.655 309.863 366.381 312.231 370.728 312.934L370.408 314.854H370.472ZM367.084 298.027C366.125 298.027 364.655 299.435 364.08 300.458C363.249 301.866 362.993 303.849 363.376 305.769C364.783 305.513 366.573 304.873 367.723 303.146C368.299 302.314 368.618 300.522 368.171 299.243C367.979 298.731 367.66 298.027 367.148 298.027C367.148 298.027 367.148 298.027 367.084 298.027ZM350.719 293.741C351.167 294.124 351.614 294.572 352.126 294.956C356.281 298.283 359.285 298.539 360.372 297.259C360.819 296.748 361.011 296.044 360.947 295.34C360.819 294.316 360.244 293.357 359.221 292.653C357.751 291.565 355.578 290.925 354.171 291.245C353.404 291.437 352.701 291.821 351.998 292.205C351.422 292.589 350.975 293.101 350.655 293.741H350.719ZM332.692 281.393C331.35 281.393 330.519 281.712 330.071 282.352C329.112 283.696 329.112 285.935 330.071 287.79C331.094 289.838 332.5 291.757 334.098 293.037C337.231 295.66 341.258 296.492 344.518 295.276C345.925 294.764 346.692 293.932 347.011 292.845C347.011 292.781 347.011 292.653 347.011 292.589C346.372 291.821 345.861 291.053 345.349 290.35C344.39 288.942 343.432 287.662 342.153 286.447C339.34 283.888 336.272 281.456 332.82 281.393H332.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.294 292.66L322.988 303.187C314.8 307.886 303.554 307.23 291.18 300.127C266.251 285.812 245.943 250.624 245.943 221.702L264.249 211.175C264.249 240.097 284.557 275.285 309.486 289.6C321.86 296.703 333.106 297.359 341.294 292.66Z",
    fill: "url(#paint4_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.373 192.16L277.678 181.633C269.381 186.405 264.249 196.641 264.249 211.175L245.943 221.702C245.943 207.132 251.075 196.896 259.373 192.16Z",
    fill: "#889A97"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M254.933 216.493C254.933 245.415 275.24 280.603 300.17 294.918C325.099 309.234 345.407 297.359 345.407 268.437C345.407 239.514 325.099 204.327 300.17 190.011C275.24 175.696 254.933 187.571 254.933 216.493Z",
    fill: "#A4C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.369 184.584L273.675 174.057C282.955 168.738 295.729 169.467 309.814 177.554C338.128 193.8 361.201 233.759 361.201 266.615L342.895 277.142C342.895 244.286 319.858 204.363 291.508 188.081C277.424 179.994 264.649 179.266 255.369 184.584Z",
    fill: "url(#paint5_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.952 300.164L327.646 310.691C337.036 305.3 342.895 293.68 342.895 277.142L361.201 266.615C361.201 283.153 355.378 294.773 345.952 300.164Z",
    fill: "#889A97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.859 277.142C342.859 309.999 319.822 323.476 291.471 307.23C263.121 290.984 240.12 250.989 240.12 218.169C240.12 185.349 263.157 171.835 291.508 188.081C319.822 204.327 342.895 244.286 342.895 277.142H342.859ZM245.943 221.702C245.943 250.624 266.251 285.812 291.18 300.127C316.11 314.443 336.417 302.568 336.417 273.646C336.417 244.723 316.11 209.536 291.18 195.22C266.251 180.905 245.943 192.78 245.943 221.702Z",
    fill: "#DBE0DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.023 283.444C343.951 289.163 347.881 291.567 352.831 288.835C357.744 286.103 361.82 279.219 361.893 273.5C361.965 267.781 358.035 265.377 353.085 268.109C348.172 270.841 344.096 277.725 344.023 283.444Z",
    fill: "#52586C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.951 301.184C368.552 302.094 370.736 301.985 373.138 300.637C378.051 297.905 382.127 291.021 382.2 285.302C382.2 282.388 381.254 280.348 379.58 279.401L359.272 267.599C360.91 268.546 361.929 270.586 361.892 273.5C361.82 279.219 357.78 286.067 352.83 288.835C350.392 290.183 348.208 290.292 346.644 289.382C352.721 292.915 360.873 297.65 366.951 301.184Z",
    fill: "#52586C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.644 289.345L366.951 301.147C365.314 300.2 364.295 298.16 364.331 295.246L344.023 283.444C344.023 286.358 344.97 288.398 346.644 289.345Z",
    fill: "url(#paint6_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.898 294.736L364.331 295.246C364.258 300.965 368.189 303.369 373.138 300.637C378.051 297.905 382.127 291.021 382.2 285.302C382.273 279.583 378.343 277.179 373.393 279.911C368.48 282.643 364.404 289.527 364.331 295.246L367.898 294.736C367.934 290.474 370.955 285.375 374.63 283.298C378.306 281.259 381.254 283.043 381.181 287.305C381.108 291.567 378.124 296.667 374.448 298.743C370.773 300.819 367.825 298.998 367.898 294.736Z",
    fill: "#889A97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.58 279.401L359.272 267.599C357.671 266.688 355.487 266.797 353.085 268.145C348.172 270.877 344.096 277.762 344.023 283.48L364.331 295.283C364.404 289.564 368.443 282.716 373.393 279.947C375.831 278.599 378.015 278.49 379.58 279.401Z",
    fill: "url(#paint7_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.142 345.514C445.67 346.461 447.818 346.388 450.22 345.077C454.951 342.418 458.845 335.825 458.918 330.324C458.918 327.447 457.935 325.48 456.297 324.569C430.603 310.654 404.91 296.776 379.18 282.861C380.453 283.553 381.218 285.083 381.218 287.305C381.181 291.567 378.161 296.667 374.485 298.743C372.629 299.763 370.955 299.836 369.79 299.107C394.574 314.588 419.358 330.033 444.142 345.514Z",
    fill: "#52586C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.454 347.445C448.982 348.319 451.093 348.246 453.422 346.935C458.153 344.276 462.047 337.683 462.12 332.182C462.12 329.377 461.21 327.41 459.609 326.5L456.406 324.642C457.971 325.553 458.954 327.52 458.918 330.325C458.845 335.825 454.951 342.418 450.219 345.077C447.89 346.388 445.78 346.461 444.251 345.587C445.234 346.133 446.507 346.898 447.454 347.445Z",
    fill: "#52586C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.754 299.107C394.538 314.588 419.322 330.033 444.106 345.514C442.577 344.567 441.667 342.637 441.704 339.905L367.861 294.773C367.861 296.885 368.553 298.379 369.717 299.144L369.754 299.107Z",
    fill: "#4E5468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.251 345.587L447.454 347.444C445.889 346.534 444.906 344.567 444.943 341.762L441.74 339.904C441.74 342.709 442.65 344.676 444.251 345.587Z",
    fill: "#464C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.297 324.569C430.603 310.655 404.91 296.776 379.179 282.861C378.015 282.242 376.414 282.315 374.63 283.299C370.955 285.338 367.934 290.474 367.897 294.736L441.74 339.868C441.813 334.368 445.707 327.775 450.438 325.116C452.731 323.841 454.769 323.731 456.297 324.533V324.569Z",
    fill: "url(#paint8_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.677 327.01C448.945 329.669 445.051 336.262 444.979 341.762C444.906 347.262 448.691 349.594 453.458 346.935C458.226 344.276 462.083 337.682 462.156 332.182C462.229 326.682 458.444 324.35 453.677 327.01Z",
    fill: "url(#paint9_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.609 326.5L456.407 324.642C454.878 323.768 452.767 323.841 450.438 325.152C445.707 327.811 441.813 334.404 441.74 339.905L444.943 341.762C445.016 336.262 448.91 329.669 453.641 327.01C455.97 325.698 458.081 325.626 459.609 326.5Z",
    fill: "url(#paint10_linear_6128_39319)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M304.9 243.558C317.493 263.264 322.442 282.606 316 286.723C309.559 290.839 294.092 278.235 281.499 258.492C268.907 238.749 263.958 219.444 270.399 215.327C276.841 211.211 292.308 223.815 304.9 243.558Z",
    fill: "#C7DBF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_6128_39319",
    x: -20.5,
    y: 187.5,
    width: 681,
    height: 489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 80
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.8 0 0 0 0 0.870588 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6128_39319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6128_39319",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.756863 0 0 0 0 0.866667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6128_39319"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6128_39319",
    result: "effect3_innerShadow_6128_39319"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6128_39319",
    x1: 294.336,
    y1: 357.656,
    x2: 305.345,
    y2: 338.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#326DCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62A1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6128_39319",
    x1: 284.172,
    y1: 354.841,
    x2: 296.141,
    y2: 334.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BDC8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6128_39319",
    x1: 371.879,
    y1: 99.1791,
    x2: 383.464,
    y2: 79.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#96A7CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6128_39319",
    x1: 365.614,
    y1: 90.9896,
    x2: 376.559,
    y2: 72.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#62A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9EC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#80B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6128_39319",
    x1: 316.183,
    y1: 307.194,
    x2: 261.592,
    y2: 212.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#889A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A5B2B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CDD4D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#DDE2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#889A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#889A97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6128_39319",
    x1: 344.569,
    y1: 276.232,
    x2: 282.545,
    y2: 168.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#889A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#889A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#DDE2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CDD4D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5B2B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#889A97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6128_39319",
    x1: 354.541,
    y1: 294.008,
    x2: 356.473,
    y2: 290.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#889A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#BCC6C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6128_39319",
    x1: 355.56,
    y1: 290.183,
    x2: 366.311,
    y2: 271.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BCC6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DCE1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#DDE2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CDD4D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A5B2B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#889A97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6128_39319",
    x1: 405.783,
    y1: 319.105,
    x2: 416.06,
    y2: 301.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4E5468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4E5468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#797E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4E5468"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6128_39319",
    x1: 457.825,
    y1: 344.385,
    x2: 449.261,
    y2: 329.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#373E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#444A60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6128_39319",
    x1: 444.688,
    y1: 341.617,
    x2: 454.965,
    y2: 323.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4E5468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4E5468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#797E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#4E5468"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6128_39319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 660,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuiltInTransparency);
export default __webpack_public_path__ + "static/media/built-in-transparency.7af107467eb2e8084067ca4c2946a5e0.svg";
export { ForwardRef as ReactComponent };